import React, { useId, useRef } from "react";
import "./boardProjectSearch.css";

function SearchIcon() {
  return (
    <svg className="pb-board-search-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M16 16l4.5 4.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default function BoardProjectSearch({ value, onChange, visible = true }) {
  const inputId = useId();
  const inputRef = useRef(null);

  if (!visible) return null;

  const hasQuery = String(value || "").trim().length > 0;

  return (
    <div className={`pb-board-search pb-board-search--toolbar${hasQuery ? " has-query" : ""}`}>
      <form
        className="pb-board-search-form"
        onSubmit={(event) => {
          event.preventDefault();
          inputRef.current?.blur();
        }}
      >
        <label className="pb-board-search-label" htmlFor={inputId}>
          Search projects
        </label>
        <SearchIcon />
        <input
          id={inputId}
          ref={inputRef}
          type="search"
          className="pb-board-search-input"
          value={value}
          placeholder="Project or work order"
          aria-label="Search by project name or work order"
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Escape" && hasQuery) {
              event.preventDefault();
              onChange("");
            }
          }}
        />
        {hasQuery ? (
          <button
            type="button"
            className="pb-board-search-clear"
            aria-label="Clear search"
            onClick={() => {
              onChange("");
              inputRef.current?.focus();
            }}
          >
            ×
          </button>
        ) : null}
      </form>
    </div>
  );
}
